import { render, staticRenderFns } from "./MenuSection.vue?vue&type=template&id=b444841a&scoped=true&"
import script from "./MenuSection.vue?vue&type=script&lang=js&"
export * from "./MenuSection.vue?vue&type=script&lang=js&"
import style0 from "./MenuSection.vue?vue&type=style&index=0&id=b444841a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b444841a",
  null
  
)

export default component.exports